import { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import { useState } from 'react';
import { Icon } from '@mui/material';
import StudyStatusAlerts from '../ui/StudyStatusAlerts';
import WrapperModal from '../ui/WrapperModal';
import DiseaseTypeForm from '../forms/DiseaseTypeForm';
import PDFDocumentViewer from '../pdfViewer/PDFDocumentViewer';
import AuthContext from '../../store/auth-context';
import StudyQCTForm from '../forms/StudyQCTForm';
import Button from '../ui/Button';

import './StudyInformation.scss';

const StudyInformation = ({
	title,
	type,
	status,
	sponsor,
	version,
	deparment,
	fundingType,
	time,
	pi,
	qam,
	phaseOfStudy,
	nationalClinicalTrial,
	informedConsentFormDate,
	iRBApprovalDate,
	cRFOBudgetReviewCompletedDate,
	filled,
	id,
	protocolFileName,
	billingGrid,
	issue
}) => {
	const queryClient = useQueryClient();
	const authCtx = useContext(AuthContext);
	const [detailsExpanded, setDetailsExpanded] =
		useState(false);

	const [
		startProtocolInfoProcess,
		setStartProtocolInfoProcess
	] = useState();

	const completeProtocolInfoHandler = () => {
		setStartProtocolInfoProcess('START-PDF-VIEWER');
	};
	const finishProtocolInfoHandler = () => {
		setStartProtocolInfoProcess();
		queryClient.invalidateQueries('study');
	};

	const openQCTForm = () => {
		setStartProtocolInfoProcess('START-QCT');
	};

	const qctSent = () => {
		setStartProtocolInfoProcess();
		queryClient.invalidateQueries('study');
	};
	return (
		<div className='study-information-wrapper'>
			<div className='study-detail-header-container'>
				<div className='back-button'>
					<NavLink to='/dashboard'>
						<Button className='secondary-button'>
							<Icon>chevron_left</Icon>
						</Button>
					</NavLink>
				</div>
				<div className='study-title'>
					<h2>{title}</h2>
				</div>
				{billingGrid.length > 0 && (
					<div className='billing-grid-button'>
						<NavLink to={`/billing-grid/${id}`}>
							<Button className='primary-button'>
								Go to Billing Grid
							</Button>
						</NavLink>
					</div>
				)}
				{!filled && authCtx.userData.role === 'QA' && (
					<div>
						<Button
							className='primary-button'
							onClick={completeProtocolInfoHandler}
						>
							Complete Protocol Information
						</Button>
					</div>
				)}
			</div>
			<div className='study-alert'>
				<StudyStatusAlerts
					type={type}
					status={status}
					issue={issue}
				/>
			</div>
			<form className='first-study-information-container'>
				<div className='control-container row'>
					<div className='col-sm-4'>
						<label>Funding Sponsor</label>
						<input
							value={sponsor}
							className='form-control'
							disabled
						/>
					</div>
					<div className='col-sm-4'>
						<label>Protocol Version</label>
						<input
							value={version}
							className='form-control'
							disabled
						/>
					</div>
					<div className='col-sm-4'>
						<label>Q.A.M. Name</label>
						<input
							value={`${qam?.firstname} ${qam?.lastname}`}
							className='form-control'
							disabled
						/>
					</div>
				</div>
				<div className='control-container row'>
					<div className='col-sm-4'>
						<label>Department</label>
						<input
							value={deparment}
							className='form-control'
							disabled
						/>
					</div>
					<div className='col-sm-4'>
						<label>Date Completed</label>
						<input
							type='date'
							value={time}
							className='form-control'
							disabled
						/>
					</div>
					<div className='col-sm-4'>
						<label>Completed By</label>
						<input
							value={`${pi?.firstname} ${pi?.lastname}`}
							className='form-control'
							disabled
						/>
					</div>
				</div>
				{!detailsExpanded && (
					<div className='control-button'>
						<Button
							className='secondary-button'
							onClick={() =>
								setDetailsExpanded(!detailsExpanded)
							}
						>
							See All
						</Button>
					</div>
				)}
				{detailsExpanded && (
					<div>
						<div className='control-container row'>
							<div className='col-sm-4'>
								<label>Funding Type</label>
								<input
									value={fundingType}
									className='form-control'
									disabled
								/>
							</div>
							<div className='col-sm-4'>
								<label>Phase of Study</label>
								<input
									value={phaseOfStudy.map((element) =>
										element.replaceAll('_', ' ')
									)}
									className='form-control'
									disabled
								/>
							</div>
							<div className='col-sm-4'>
								<label>National Clinical Trial</label>
								<input
									value={nationalClinicalTrial}
									className='form-control'
									disabled
								/>
							</div>
						</div>
						<div className='control-container row'>
							<div className='col-sm-6'>
								<label>Informed Consent Form Date</label>
								<input
									type='date'
									value={informedConsentFormDate}
									className='form-control'
									disabled
								/>
							</div>
							<div className='col-sm-6'>
								<label>IRB approval date</label>
								<input
									type='date'
									value={iRBApprovalDate}
									className='form-control'
									disabled
								/>
							</div>
						</div>
						<div className='control-container row'>
							<div className='col-sm-6'>
								<label>
									CRFO Budget Review completed date
								</label>
								<input
									type='date'
									value={cRFOBudgetReviewCompletedDate}
									className='form-control'
									disabled
								/>
							</div>
						</div>
						<div>
							<Button
								className='control-button'
								onClick={() =>
									setDetailsExpanded(!detailsExpanded)
								}
							>
								See Less
							</Button>
						</div>
					</div>
				)}
			</form>
			{startProtocolInfoProcess === 'START-PDF-VIEWER' && (
				<WrapperModal onDismiss={finishProtocolInfoHandler}>
					<DiseaseTypeForm
						studyId={id}
						fileName={protocolFileName}
						onEndProcess={openQCTForm}
					/>
					<PDFDocumentViewer
						documentName={protocolFileName}
					/>
				</WrapperModal>
			)}
			{startProtocolInfoProcess === 'START-QCT' && (
				<WrapperModal onDismiss={finishProtocolInfoHandler}>
					<StudyQCTForm studyId={id} onSendQCT={qctSent} />
				</WrapperModal>
			)}
		</div>
	);
};

export default StudyInformation;
